import { useTheme } from "styled-components";

import { useGetProductSummariesQuery } from "@sso/apis/products/hooks";
import { TableHeader } from "@sso/components/TableHeader";
import { TableLayoutWrapper } from "@sso/components/TableLayoutWrapper";
import { TablePagination } from "@sso/components/TablePagination";
import { TableProvider, TableProviderState } from "@sso/context/tableContext";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectProductPagination } from "@sso/store/slices/product";
import { SoftwareSummaryKeys } from "@sso/types";
import { CircleLoading } from "@sso/ui/CircleLoading";

import ProductLicenceTable from "./productLicenceTable";
import { productLicenceTableColumns } from "./productLicenceTableColumns";

const ProductLicences = () => {
  const theme = useTheme();
  const { data, isFetching, error } = useGetProductSummariesQuery();

  const productPagination = useAppSelector(selectProductPagination);

  const tableContextInstance: TableProviderState = { ...productPagination, columns: productLicenceTableColumns };
  const datakeys = [SoftwareSummaryKeys.NAME, SoftwareSummaryKeys.NUMBER_OF_LICENCED_USERS];

  const TableActions = <></>;

  return (
    <>
      {isFetching && <CircleLoading color={theme.colors.secondary.dark} size={8} blurBackground />}
      <TableProvider tableInstance={tableContextInstance}>
        <TableHeader title="Products" TableActions={TableActions} />
        <TableLayoutWrapper error={error} data={data}>
          {data && (
            <ProductLicenceTable
              data={data.resources}
              productLicenceTableColumns={productLicenceTableColumns}
              dataKeys={datakeys}
            />
          )}
        </TableLayoutWrapper>
        <TablePagination totalPages={data?.totalPages} />
      </TableProvider>
    </>
  );
};

export default ProductLicences;
